import { Link } from "react-router-dom";
import { money, PLACEHOLDER_IMG } from "@/lib/api";
import { WatermarkOverlay, noSave, productAlt } from "@/components/WatermarkOverlay";
import { useCurrency } from "@/context/CurrencyContext";

export const ProductCard = ({ p, index = 0 }) => {
  const { localEstimate } = useCurrency();
  const est = localEstimate(p.price);
  return (
  <Link to={`/product/${p.slug}`} data-testid={`product-card-${p.slug}`}
    className="group block bg-white border border-[#D9CBA0]/40 overflow-hidden transition-all duration-500 hover:border-[#D9CBA0] hover:-translate-y-1 gh-fade-up"
    style={{ animationDelay: `${index * 60}ms` }}>
    <div className="relative aspect-[4/5] overflow-hidden bg-[#F2EFEB]">
      <img src={p.image || PLACEHOLDER_IMG} alt={productAlt(p)} loading="lazy" {...noSave}
        className="h-full w-full object-cover transition-transform duration-[1.1s] ease-out group-hover:scale-[1.04]" />
      <WatermarkOverlay />
      {p.badge && (
        <span className="absolute top-3 left-3 bg-[#FAF7F2]/95 text-[#3A3632] text-[10px] tracking-[0.16em] uppercase font-medium px-3 py-1 border border-[#D9CBA0]/60">{p.badge}</span>
      )}
    </div>
    <div className="p-6">
      <h3 className="font-heading text-2xl text-[#3A3632] leading-snug">{p.name}</h3>
      <p className="text-sm text-[#6B655F] mt-2 line-clamp-2 leading-relaxed">{p.short_desc}</p>
      <div className="gh-hairline my-4" />
      <div className="flex items-center justify-between">
        <span className="text-[#8E9A86] text-lg">
          {money(p.price)}
          {est && <span className="text-xs text-[#8A8175] ml-1.5" data-testid={`card-local-price-${p.slug}`}>≈ {est}</span>}
        </span>
        <span className="gh-overline text-[10px] group-hover:text-[#8E9A86] transition-colors">View</span>
      </div>
    </div>
  </Link>
  );
};
